import { LinkedInCircleIcon } from '@/component/Icons/LinkedInCircleIcon';

export const navigation = {
  product: [{ name: 'menu.first', href: '/#search-box' }],
  company: [
    { name: 'about.hero.title', href: '/about' },
    { name: 'partner.hero.title', href: '/partners' },
    { name: 'system-status', href: 'https://guestit.appsignal-status.com/' },
  ],
  host: [
    { name: 'menu.second', href: '/onboarding' },
    { name: 'menu.seventh', href: '/pricing' },
    { name: 'menu.eighth', href: '/security' },
    { name: 'menu.ninth', href: '/insurance' },
  ],
  legal: [],
  blogs: [{ name: 'blog.hero.all', href: '/blogs' }],
  contacts: [{ name: '+468356564', href: 'tel:+468356564', before: 'call-us' }],
  social: [
    {
      name: 'Linkedin',
      href: 'https://www.linkedin.com/company/guestit/',
      icon: (props) => <LinkedInCircleIcon {...props} />,
    },
  ],
};
